export default "__VITE_PUBLIC_ASSET__64611a6f__"